import React from 'react';

// Renders a user's avatar image, falling back to a colored circle with their
// initial when there's no avatarUrl (or it fails to load).
const Avatar = ({ user, color, size = 'w-9 h-9', textSize = 'text-xs', ring = '', imgBorder = '' }) => {
  const bgColor = color || user?.color || 'oklch(0.72 0.155 48)';

  return (
    <div className={`${size} rounded-full overflow-hidden flex-shrink-0 shadow-sm relative ${ring}`}>
      {user?.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt=""
          className={`w-full h-full object-cover ${imgBorder}`}
          style={{
            objectPosition: user.avatarPosition || '50% 50%',
            transform: `scale(${user.avatarZoom || 1})`,
            transformOrigin: user.avatarPosition || '50% 50%',
          }}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className={`w-full h-full items-center justify-center text-ink-shell ${textSize} font-serif`}
        style={{
          backgroundColor: bgColor,
          display: user?.avatarUrl ? 'none' : 'flex'
        }}
      >
        {user?.name?.[0]}
      </div>
    </div>
  );
};

export default Avatar;
